/**
 * Replaces characters that are invalid in file names on common
 * filesystems (/ \ : * ? " < > |) so the resulting name can be
 * written via Capacitor Filesystem or used as a download name.
 */
export function sanitizeFileName(fileName: string): string {
  return fileName.replace(/[/\\:*?"<>|]/g, '-').trim();
}
